<template>
	<div class="popup" v-show="isshow">
		<div v-for="index of count"><!-- 错误提示框 -->
		<div class="error" v-if="types=='error'">
			<div class="error1">
				<img src="../../assets/images/error.png" />
				<div>
					{{message}}
				</div>
			</div>
		</div>
		<!-- 成功提示框 -->
		<div class="success" v-else-if="types=='success'">
			<div class="success1">
				<img src="../../assets/images/success.png" />
				<div>
					{{message}}
				</div>
			</div>
		</div>
		<!-- 警告提示框 -->
		<div class="warning" v-else-if="types=='warning'">
			<div class="warning1">
				<img src="../../assets/images/warning.png" />
				<div>
					{{message}}
				</div>
			</div>
		</div></div>
	</div>
</template>

<script>
	export default{
		name:'popup',
		data(){
			return{
				isshow: true,
				time: 0,
				count: 0
			}
		},
		props:{
			types: {
				default: 'success'
			},
			message:{
				default:null
			}
		},
		methods:{
			popupshow(){
				if(this.count<1){
					this.count+=1
					setTimeout(()=>{
						this.count-=1
					},1500)
				}
			}
		}
	}
</script>

<style>
	.popup{
		position: fixed;
		z-index: 99;
		font-size: 1.5rem;
		margin: auto;
		left: 0px;
		right: 0px;
		top: 6rem;
		width: 50rem;
	}
	.popup .warning,.success,.error{
		width: 30rem;
		height: 6rem;
		margin: 0px auto;
		position: relative;
	}
	.popup .warning{
		background: rgba(197,141,68,0.35);
	}
	.popup .success{
		background: rgba(53,98,78,0.35);
	}
	.popup .error{
		background: rgba(167,58,41,0.35);
	}
	.popup .warning1,.success1,.error1{
		position: absolute;
		top: 0.3rem;
		left: 0.3rem;
		right: 0.3rem;
		bottom: 0.3rem;
	}
	.popup .warning1{
		background: rgba(197,141,68,0.9);
	}
	.popup .success1{
		background: rgba(53,98,78,0.9);
	}
	.popup .error1{
		background: rgba(167,58,41,0.9);
	}
	.popup .warning1 img,.success1 img,.error1 img{
		width: 2.5rem;
		height: 2.5rem;
		display: block;
		padding: calc((3.5rem - 0.6rem) / 2);
		float: left;
	}
	.popup .warning1 div,.success1 div,.error1 div{
		float: left;
		height: 3rem;
		width: 23rem;
		padding-top: calc((3rem - 0.6rem) / 2);
		line-height: 3rem;
		font-size: 1.2rem;
		color: #FFFFFF;
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
</style>
